import { clearAssistantFabIntroDone } from '../../use-assistant-fab-intro'
import { useCore } from '@/composables/core'
import type { RootState } from '@/types/store'
import type { Store } from 'vuex'
import { useBooksyAssistantStore } from '../../../store'
import { buildAgentCredentialHeaders } from '../use-agent-session/utils/session-context'
import { terminateAgentSession } from '../use-agent-session/utils/agent-client'
import { clearAllChatStates } from '../use-agent-persistence/utils/storage'

function terminateSessionIfAuthenticated (
  userId: string | number,
  sessionId: string
): void {
  try {
    const { store } = useCore()
    const credentialHeaders = buildAgentCredentialHeaders(store as Store<RootState>)
    if (!credentialHeaders) {
      return
    }
    const country = store.state.app.country
    terminateAgentSession({ userId, sessionId, credentialHeaders, country })
  } catch {
    // Best-effort cleanup when the app shell is not initialized (e.g. unit tests).
  }
}

export function destroyBooksyAssistant (): void {
  const store = useBooksyAssistantStore()

  if (store.restoredUserId && store.sessionId) {
    terminateSessionIfAuthenticated(store.restoredUserId, store.sessionId)
  }

  store.messages = []
  store.sessionId = null
  store.isOpen = false
  store.draft = ''
  store.error = null
  store.isSending = false
  store.voiceAutoSend = false
  store.restoredUserId = null
  store.restoredBusinessId = null
  clearAllChatStates()
  clearAssistantFabIntroDone()
}
